import React, { useRef, useState } from 'react'
import { TableComp } from 'sz-react-utils-lite'
import { Drawer, Card, Button, Table, Tabs } from 'antd'
import { DisplayDate, DefaultTablePagination } from '../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import { getMemberHistory } from '../actions'
import ChangeHistory from '../drawers/changeHistory'
import OnlineSubmissionComp from '../../searchResult/components/onlineSubmissionComp'
import ArticleHistoryTable from '../components/ArticleHistoryTable'

const { TabPane } = Tabs

const MemberHistory = (props) => {
    let { visible, onClose, articleId, ids, data } = props
    let [changeHistoryVisible, setChangeHistoryVisible] = useState(false)
    let [selectedReviewer, setSelectedReviewer] = useState({})
    const table = useRef()
    const dispatch = useDispatch()
    const columns = [
        {
            title: 'Article No',
            key: 'articleNo',
            dataIndex: 'articleNo'
        },
        {
            title: 'Abstract No',
            key: 'abstractNo',
            dataIndex: 'articleNo'
        },
        {
            title: 'Send Date',
            key: 'selectedReviewer.sendDate',
            dataIndex: 'selectedReviewer.sendDate',
            render: (item) => {
                return item ? DisplayDate(item) : null
            }
        },

        {
            title: 'Remarks',
            key: 'selectedReviewer.remarks',
            dataIndex: 'selectedReviewer.remarks',
            render: (item, record) => {
                return (
                    <div>
                        {item}
                        {record.selectedReviewer && record.selectedReviewer.comments ? <div>
                            Comments :- {record.selectedReviewer.comments}
                        </div> : null}
                    </div>
                )
            }
        },
        {
            title: 'Reminder Date',
            key: 'selectedReviewer.reminderDate',
            dataIndex: 'selectedReviewer.reminderDate',
            render: (item) => {
                return item ? DisplayDate(item) : null
            }
        },
        {
            title: 'Received Date',
            key: 'selectedReviewer.receiveDate',
            dataIndex: 'selectedReviewer.receiveDate',
            render: (item) => {
                return item ? DisplayDate(item) : null
            }
        },

        {
            title: 'Action',
            key: 'actions',
            width: 280,
            render: (val, record) => (
                <React.Fragment>
                    {(record.selectedReviewer.remarks || record.selectedReviewer.comments || record.selectedReviewer.receiveDate) ?
                        <Button className={'roundSmallBtn'} onClick={() => events.showDrawer(record.selectedReviewer)}>Change
                            History</Button> : null}
                </React.Fragment>)

        }


    ]
    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let obj = {
                ...params,
                id: props.reviewerId
            }
            let regExpFilters = []
            let data = await dispatch(getMemberHistory({ ...obj, regExFilters: regExpFilters }))
            console.log("API Response Data:", data);
            resolve(data)
        })
    }

    const events = {
        showDrawer: (data) => {
            setChangeHistoryVisible(true)
            setSelectedReviewer({
                articleId: articleId,
                ...data
            })
        },
        hideDrawer: () => {
            setChangeHistoryVisible(false)
        },
        submitCallback: () => {
            setSelectedReviewer({})
            setChangeHistoryVisible(false)
            table.current.reload()
        }

    }

    const apcColumns = [
        {
            title: 'Member ID',
            key: 'reviewerId',
            render: () => data.reviewerId || ''
        },
        {
            title: 'Waived By',
            dataIndex: 'addedBy',
            key: 'addedBy'
        },
        {
            title: 'Waiver Count',
            dataIndex: 'count',
            key: 'count'
        },
        {
            title: 'Date & Time',
            dataIndex: 'addedOn',
            key: 'addedOn',
            render: (val) => val ? DisplayDate(val) + ' ' + new Date(val).toLocaleTimeString() : ''
        }
    ]

    return (
        <Drawer
          title={data.reviewerId ? `History Details | ${data.name} | ${data.reviewerId}` : `History Details | ${data.name}`}
          width={'65%'}
          visible={visible}
          placement='right'
          onClose={onClose}>
          <Card>
            <Tabs defaultActiveKey='1'>
              <TabPane tab='Reviewer History' key='1'>
                <TableComp ref={table} columns={columns} apiRequest={apiRequest}
                           pagination={DefaultTablePagination({}, 50)} />
              </TabPane>

              <TabPane tab='APC Waiver History' key='2'>
                <Table
                  columns={apcColumns}
                  dataSource={data.apcWaiverHistory || []}
                  rowKey={(record, index) => index}
                  pagination={false}
                  size='small'
                  bordered
                />
              </TabPane>

              <TabPane tab='Online Submission' key='3'>
                {data.email ? <OnlineSubmissionComp defaultSearchTerm={data.email} /> : <div style={{padding: 20}}>No email found for this reviewer to perform search.</div>}
              </TabPane>
              
              <TabPane tab='Article History' key='4'>
                {data.email ? <ArticleHistoryTable emailId={data.email} /> : <div style={{padding: 20}}>No email found for this reviewer to fetch article history.</div>}
              </TabPane>
            </Tabs>

            {changeHistoryVisible ?
              <ChangeHistory visible={changeHistoryVisible} selectedReviewer={selectedReviewer}
                             onClose={events.hideDrawer}
                             onSubmit={events.submitCallback} />
              : null}
          </Card>

        </Drawer>
    )
}

export default MemberHistory
